import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useGetCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useGetCertificadoEmpresaItByID';
import { jwtDecode } from 'jwt-decode';
import useDecode from 'hooks/useDecode';
import SolicitudRiesgoEmbarazoLactancia from './SolicitudRiesgoEmbarazoLactancia';
import useGetRiesgoEmbarazoLactanciaByID from 'services/record/RiesgoEmbarazoLactancia/useGetRiesgoEmbarazoLactanciaByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialRiesgoEmbarazoLactancia = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetRiesgoEmbarazoLactanciaByID, errorGetRiesgoEmbarazoLactanciaByID, getRiesgoEmbarazoLactanciaByID, loadingGetRiesgoEmbarazoLactanciaByID, successGetRiesgoEmbarazoLactanciaByID } = useGetRiesgoEmbarazoLactanciaByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getRiesgoEmbarazoLactanciaByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Solicitud de Riesgo de Embarazo y Lactancia'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetRiesgoEmbarazoLactanciaByID ?
                    <Loader activeLoader={loadingGetRiesgoEmbarazoLactanciaByID} label="Cargando Formulario"></Loader>
                    :
                    <SolicitudRiesgoEmbarazoLactancia dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialRiesgoEmbarazoLactancia